.track {
  position: relative;
  flex: none;
  align-self: center;
  width: var(--track-width);
  height: var(--track-height);
  margin: 0 calc(var(--thumb-size) / 2); /* make track end in middle of thumbs */
  background-color: var(--h5w-domainSlider-track--bgColor, lightgray);
  box-shadow: 1px 1px 2px inset var(--h5w-domainSlider-track--shadowColor, gray);
  border-radius: calc(var(--track-height) / 2);
  overflow: hidden; /* crop data track to root track's border radius */
}

.dataTrack {
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: var(--h5w-domainSlider-dataTrack--bgColor, royalblue);
  box-shadow: 0 -2px 3px inset
    var(--h5w-domainSlider-dataTrack--shadowColor, midnightblue);
  border-radius: 2px;
}
